import { makeStyles } from '@soil-capital/ui-kit/style';

export const useCommitmentStyle = makeStyles()((theme) => ({
    padding: { paddingLeft: theme.spacing(1) },
}));
